// This file is used to share types between client and server
// For more information about this file see https://dove.feathersjs.com/guides/cli/service.shared.html
import type { ClientApplication } from '../../client';
import type { Tag, TagData, TagPatch, TagQuery, TagService } from './tag.class';

export type { Tag, TagData, TagQuery, TagPatch };

export const tagPath = 'api/tag';

export const tagMethods: Array<keyof TagService> = [
  'find',
  'get',
  'create',
  'patch',
  'remove',
  'uploadLogo',
];

export type TagClientService = Pick<TagService, (typeof tagMethods)[number]>;

export const tagClient = (client: ClientApplication) => {
  const connection = client.get('connection');

  client.use(tagPath, connection.service(tagPath), {
    methods: tagMethods,
  });
};

// Add this service to the client service type index
declare module '../../client' {
  interface ServiceTypes {
    [tagPath]: TagClientService;
  }
}
